import { t } from "@lingui/macro";
import * as React from "react";
import { ClipPath, Defs, G, Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const MessageIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Message`} {...props}>
    <G clipPath="url(#a)">
      <Path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        d="M1.25 14a.75.75 0 0 0 1.28.53l2.707-2.707a.25.25 0 0 1 .177-.073H13A1.75 1.75 0 0 0 14.75 10V3A1.75 1.75 0 0 0 13 1.25H3A1.75 1.75 0 0 0 1.25 3v11Z"
        fill="none"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="none" d="M0 0h16v16H0z" />
      </ClipPath>
    </Defs>
  </Icon>
);
